import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { TurnoModel } from '../models/TurnoModel';
import { obtenerTurnosService, obtenerTurnoPorIdService } from '../../../../service/catalogos/Turno';

export const useObtenerTurnos = (reload: number) => {
  const [data, setData] = useState<TurnoModel[]>([]);
  const [loadingRequest, setLoadingRequest] = useState(false);
  const history = useHistory();

  useEffect(() => {
    const fetchData = async () => {
      setLoadingRequest(true);
      const res = await obtenerTurnosService()
        .then()
        .catch(() => {
          setLoadingRequest(false);
          history.push('/error/500');
        });
      if (res) {
        setData(res.rows ?? res);
        setLoadingRequest(false);
      }
    };
    fetchData();
  }, [reload]);

  return { data, loadingRequest };
};

export const useObtenerTurnoPorId = (id: number) => {
  const initModel: TurnoModel = { id: 0, nombre: '', is_active: true };
  const [initValues, setInitValues] = useState<TurnoModel>(initModel);
  const history = useHistory();

  useEffect(() => {
    const fetchData = async () => {
      const res = await obtenerTurnoPorIdService(id)
        .then()
        .catch(() => {
          history.push('/error/500');
        });
      if (res) {
        setInitValues(res);
      }
    };
    if (id) {
      fetchData();
    } else {
      setInitValues(initModel);
    }
  }, [id]);

  return { initValues };
};
